/*
 *
 * Alfresco Folder Structure reducer
 *
 */
import { fromJS } from 'immutable';
import * as constants from './constants';

const initialState = {};
export function alfrescoFolderStructureReducer(state = fromJS(initialState), action) {
  switch (action.type) {
    case constants.SET_ALFRESCO_FOLDER_STRUCTURE:
      return state
        .set(action.id, fromJS(action.folderStructure));
    default:
      return state;
  }
}
